import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getInvoices } from "../services/statisticsService"; // ✅ Replace with actual service to fetch invoices

function Invoices() {
    const [invoices, setInvoices] = useState([]);
    const [viewAll, setViewAll] = useState(false);

    useEffect(() => {
        fetchInvoices();
    }, []);

    // ✅ Fetch real invoices from backend
    const fetchInvoices = async () => {
        try {
            const invoicesResponse = await getInvoices(); // Call API service
            if (invoicesResponse.success) {
                const sortedInvoices = invoicesResponse.data.sort(
                    (a, b) => new Date(b.invoice_date) - new Date(a.invoice_date)
                ); // Sort invoices by most recent date
                setInvoices(sortedInvoices);
            }
        } catch (error) {
            console.error("Error fetching invoices:", error);
        }
    };

    const displayedInvoices = viewAll ? invoices : invoices.slice(0, 2); // Show 2 most recent invoices by default

    return (
        <Section>
            <div className="invoices">
                <div className="invoices__details">
                    <div>
                        <h4>Recent Invoices</h4>
                    </div>
                    <div>
                        <button onClick={() => setViewAll(!viewAll)}>
                            {viewAll ? "SHOW LESS" : "SEE ALL"}
                        </button>
                    </div>
                </div>

                <div className="invoices__table">
                    <table>
                        <thead>
                        <tr>
                            <th>Invoice No</th>
                            <th>Customer NIC</th>
                            <th>Date</th>
                            <th>Final Amount</th>
                            <th>Sales Representative</th>
                            <th>Payment Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        {displayedInvoices.length > 0 ? (
                            displayedInvoices.map((invoice) => (
                                <tr key={invoice.id}>
                                    <td>#{invoice.invoice_number}</td>
                                    <td>{invoice.customer_id}</td>
                                    <td>{new Date(invoice.invoice_date).toLocaleDateString()}</td>
                                    <td>RS. {parseFloat(invoice.final_amount).toFixed(2)}</td>
                                    <td>{invoice.FirstName} {invoice.LastName}</td>
                                    <td>
                                        <button
                                            className={
                                                invoice.payment_status === "Completed"
                                                    ? "complete"
                                                    : invoice.payment_status === "Pending"
                                                        ? "pending"
                                                        : "cancelled"
                                            }
                                        >
                                            {invoice.payment_status}
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6">No invoices found.</td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
            </div>
        </Section>
    );
}

export default Invoices;

// ✅ Styled Components
const Section = styled.section`
    .invoices {
        color: black;
        width: 100%;
        padding: 1rem;
        background-color: #f7f9fc;
        border-radius: 1rem;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);

        .invoices__details {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1rem;

            h4 {
                font-weight: bold;
                font-size: 1rem;
            }

            button {
                padding: 0.5rem 1rem;
                background-color: #668dff;
                color: white;
                border: none;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: bold;
                transition: background-color 0.3s;

                &:hover {
                    background-color: #4a6ed1;
                }
            }
        }

        .invoices__table {
            margin-top: 1rem;
            table {
                border-collapse: collapse;
                width: 100%;
                background-color: #ffffff;
                border-radius: 0.75rem;
                overflow: hidden;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

                th, td {
                    text-align: center;
                    padding: 0.8rem;
                    border-bottom: 1px solid #ddd;

                    button {
                        border-radius: 0.3rem;
                        padding: 0.3rem 0.8rem;
                        border: none;
                        font-weight: bold;
                    }

                    .complete {
                        background-color: #e0ffe4;
                        color: green;
                    }

                    .pending {
                        background-color: #fff8e1;
                        color: #e6b800;
                    }

                    .cancelled {
                        background-color: #ffe4e4;
                        color: red;
                    }
                }

                thead {
                    background-color: #668dff;
                    color: white;
                }
            }
        }
    }
`;
